import {getOrganizerArticlesForPlaceId} from './api';
import {
    followOrganizer as followOrganizerApi,
} from 'consumer-utils/redux/organizers/api';
import {
    SET_ORGANIZER_ARTICLES,
    FOLLOW_ORGANIZER,
} from './actionTypes';
import {transformFiveToFollowResponse} from '../utils';
import {setOrganizerArticlesLoading} from '../app/actions';

const setOrganizerArticles = (data) => ({
    type: SET_ORGANIZER_ARTICLES,
    payload: transformFiveToFollowResponse(data),
});

const setFollowOrganizer = (id, value) => ({
    type: FOLLOW_ORGANIZER,
    payload: {
        id,
        value,
    },
});

export const addOrganizerArticles = (locationData) => (
    (dispatch, getState) => {
        const {
            location: userLocation,
        } = getState();
        const {placeId} = locationData || userLocation;

        dispatch(setOrganizerArticlesLoading(true));

        return getOrganizerArticlesForPlaceId(placeId)
            .then((response) => {
                dispatch(setOrganizerArticles(response));
                dispatch(setOrganizerArticlesLoading(false));
            })
            .catch(() => {
                dispatch(setOrganizerArticles([]));
            });
    }
);

export const followOrganizer = (id) => (
    (dispatch) => {
        followOrganizerApi(id).then(() => {
            dispatch(setFollowOrganizer(id, true));
        });
    }
);
